import * as React from 'react';
import { AuthUserProvider } from './AuthUserContext';
import { useAuthUser } from './useAuthUser';
import { AuthUser as AuthUserModel } from './AuthUserModels';

export const AuthUser: React.FC<React.PropsWithChildren<{ user: AuthUserModel | undefined }>> = ({
  children,
  user
}) => {
  const context = useAuthUser(user);
  return <AuthUserProvider value={context}>{children}</AuthUserProvider>;
};
